export default {
  /** T+ 推送摘要、完整报文及按原工单重新查询重试，地址与后端 Controller 保持一致。 */
  tplusPushRecordPage: '/ygsjzs/tplusPushRecord/page',
  tplusPushRecordDetail: '/ygsjzs/tplusPushRecord/detail',
  tplusPushRecordRetry: '/ygsjzs/tplusPushRecord/retry',
  /** 登录用户删除本地推送记录，不依赖按钮权限。 */
  tplusPushRecordDelete: '/ygsjzs/tplusPushRecord/delete',

  /** 菜单列表 */
  selectSysMenuByList: '/ygsjzs/iparkMenu/selectIparkMenuByPageList',
  /** 当前用户菜单列表 */
  selectSysMenuMyList: '/ygsjzs/iparkMenu/selectIparkMenuByList',
  /** 菜单列表分页 */
  selectSysMenuByPage: '/ygsjzs/iparkMenu/selectIparkMenuByPage',
  /** 菜单新增 */
  insertSysMenu: '/ygsjzs/iparkMenu/insertIparkMenu',
  /** 菜单修改 */
  updateSysMenu: '/ygsjzs/iparkMenu/updateIparkMenu',
  /** 菜单激活禁用 */
  disableSysMenu: '/ygsjzs/iparkMenu/disableIparkMenu',
  /** 菜单详情 */
  selectSysMenuByMenuId: '/ygsjzs/iparkMenu/selectIparkMenuByMenuId',
  selectIparkMenuTreeList: '/ygsjzs/iparkMenu/selectIparkMenuTreeList',

  /** 新增角色 */
  insertSysRole: '/ygsjzs/iparkRole/insertIparkRole',
  /** 修改角色 */
  updateSysRole: '/ygsjzs/iparkRole/updateIparkRole',
  /** 删除角色 */
  deleteSysRole: '/ygsjzs/iparkRole/deleteIparkRole',
  /** 角色详情 */
  selectSysRoleByRoleId: '/ygsjzs/iparkRole/selectIparkRoleById',
  /**  查询菜单候选下拉 */
  selectSysMenuById: '/ygsjzs/iparkRole/selectIparkMenuById',
  /** 查询角色列表 */
  selectSysRoleByList: '/ygsjzs/iparkRole/selectIparkRoleByList',

  /** 新增数据字典 */
  insertDic: '/ygsjzs/dic/insertDic',
  /** 修改数据字典 */
  updateDic: '/ygsjzs/dic/updateDic',
  /** 查询数据字典详情 */
  selectDicByDicId: '/ygsjzs/dic/selectDicByDicId',
  /** 分页数据字典列表 */
  selectDicByPage: '/ygsjzs/dic/selectDicByPage',
  /** 同步数据字典到redis  */
  synchro: '/ygsjzs/dic/synchro',
  /** 查询字典分类列表  */
  selectDicTypeByList: '/ygsjzs/dic/selectDicTypeByList',

  // 删除用户
  eliminateIparkUser: '/ygsjzs/iparkUser/eliminateIparkUser',
  /**  禁用/启用用户 */
  deleteSysUser: '/ygsjzs/iparkUser/deleteIparkUser',
  /** 分页查询用户列表 */
  selectSysUserByPage: '/ygsjzs/iparkUser/selectIparkUserByPage',
  /** 重置用户密码  */
  resetPassword: '/ygsjzs/iparkUser/resetPassword',
  /** 修改当前登录用户密码 */
  updatePassword: '/ygsjzs/iparkUser/updatePassword',
  /** 新增用户 */
  insertSysUser: '/ygsjzs/iparkUser/insertIparkUser',
  /** 修改用户 */
  updateSysUser: '/ygsjzs/iparkUser/updateIparkUser',
  /** 用户详情 */
  selectSysUserByUserId: '/ygsjzs/iparkUser/selectIparkUserByUserId',
  /** 用户列表不分页 */
  selectSysUserByList: '/ygsjzs/iparkUser/selectIparkUserByList',

  /**  新增部门组织 */
  insertSysDept: '/ygsjzs/iparkDept/insertIparkDept',
  /** 修改部门组织 */
  updateSysDept: '/ygsjzs/iparkDept/updateIparkDept',
  /**  删除部门组织 */
  deleteSysDept: '/ygsjzs/iparkDept/deleteIparkDept',
  /** 查询部门组织列表 */
  selectSysDeptByList: '/ygsjzs/iparkDept/selectIparkDeptByList',
  /** 查询部门组织详情 */
  selectSysDeptByDeptId: '/ygsjzs/iparkDept/selectIparkDeptByDeptId',

  /** 新增网格 */
  insertGrid: '/ygsjzs/grid/insertGrid',
  /** 修改网格 */
  updateGrid: '/ygsjzs/grid/updateGrid',
  /** 删除网格 */
  deleteGrid: '/ygsjzs/grid/deleteGrid',
  /** 详情 */
  selectGridByGridId: '/ygsjzs/grid/selectGridByGridId',
  /** 网格列表 */
  selectGridByPage: '/ygsjzs/grid/selectGridByPage',

  /** 预警模板获取 */
  selectTemplateByList: '/ygsjzs/template/selectTemplateByList',
  /** 获取预警配置 */
  selectConfigure: '/ygsjzs/configure/selectConfigure',
  /** 保存配置详情 */
  insertConfigure: '/ygsjzs/configure/insertConfigure',

  /** 新增消息计划 */
  insertMsgConfigure: '/ygsjzs/msgConfigure/insertMsgConfigure',
  /** 修改消息计划 */
  updateMsgConfigure: '/ygsjzs/msgConfigure/updateMsgConfigure',
  /** 物理删除消息计划 */
  deleteDataMsgConfigure: '/ygsjzs/msgConfigure/deleteDataMsgConfigure',
  /** 查询消息计划详情 */
  selectMsgConfigureById: '/ygsjzs/msgConfigure/selectMsgConfigureById',
  /** 查询消息计划列表 */
  selectMsgConfigureByList: '/ygsjzs/msgConfigure/selectMsgConfigureByList',
  /** 分页查询消息计划列表 */
  selectMsgConfigureByPage: '/ygsjzs/msgConfigure/selectMsgConfigureByPage',
  /** 短信模板下拉 */
  selectSMS: '/ygsjzs/msgConfigure/selectSMS',
  /** 语音模板下拉 */
  selectVoice: '/ygsjzs/msgConfigure/selectVoice',
  // 分页查询消息发送记录列表
  selectMsgSendByPage: '/ygsjzs/msgSend/selectMsgSendByPage',
  // 查询消息发送记录统计
  selectMsgSendStatistics: '/ygsjzs/msgSend/selectMsgSendStatistics'
}
